import { useFormContext } from 'react-hook-form';
import GoalSettingsDialog, {
  GoalSettingsValues,
} from 'components/GoalSettingsDialog';
import { FormValues } from './interfaces';

interface EditGoalSettingsDialogProps {
  goalIndex: number;
  onClose: () => void;
}

/**
 * Edit-form adapter: reads the goal's settings out of the react-hook-form state
 * and writes them back with `setValue`, leaving persistence to the form's own
 * submit. The inline-edit view wraps the same dialog with an immediate save.
 */
export default function EditGoalSettingsDialog({
  goalIndex,
  onClose,
}: EditGoalSettingsDialogProps) {
  const { getValues, setValue } = useFormContext<FormValues>();
  const path = `goals.${goalIndex}` as const;
  const initial = getValues(path);

  const handleSave = (values: GoalSettingsValues) => {
    (Object.keys(values) as Array<keyof GoalSettingsValues>).forEach((key) => {
      setValue(`${path}.${key}`, values[key], { shouldDirty: true });
    });
    onClose();
  };

  return (
    <GoalSettingsDialog
      goalName={initial?.name || 'Goal'}
      goalType={initial?.type}
      initialValues={{
        selfAssessmentSetup: initial?.selfAssessmentSetup,
        allowScorecardComment: Boolean(initial?.allowScorecardComment),
        allowScorecardOwnerEdits: Boolean(initial?.allowScorecardOwnerEdits),
        allowScorecardMetricPmOwnerEdits:
          initial?.allowScorecardMetricPmOwnerEdits ?? true,
        allowScorecardOwnerEditActualField:
          initial?.allowScorecardOwnerEditActualField ?? true,
        autoAssignPmReviewer: Boolean(initial?.autoAssignPmReviewer),
        limitReviewersToEmployeeAndPm: Boolean(
          initial?.limitReviewersToEmployeeAndPm,
        ),
      }}
      onSave={handleSave}
      onClose={onClose}
    />
  );
}
